import React, { createContext, useContext, useState } from "react";
import AccountService from "../Services/accountService";

const ParameterContext = createContext();

export const ParameterProvider = ({ children }) => {
  const [parameterState, setParameterState] = useState(null);

  return (
    <ParameterContext.Provider value={{ parameterState, setParameterState }}>
      {children}
    </ParameterContext.Provider>
  );
};

export const useParameters = () => {
  const context = useContext(ParameterContext);
  if (!context) {
    throw new Error("useParameters must be used within a ParameterProvider");
  }
  return context;
};
